import type { StyleFunctionProps } from '@chakra-ui/theme-tools';
import { mode, transparentize } from '@chakra-ui/theme-tools';

/** This theme's `gray.50`…`gray.100` are dark hexes; dark-mode inputs must not use them as "light" text. */
const DARK_FIELD_BG = '#111111';
const DARK_FIELD_FG = '#FFFFFF';
const DARK_FIELD_BORDER = '#222222';
const DARK_FIELD_BORDER_HOVER = '#363636';
const DARK_PLACEHOLDER = '#999999';

export default function getFormStyles(props: StyleFunctionProps) {
  return {
    input: {
      empty: {
        // there is no text in the empty input
        // color: ???,
        bgColor: props.bgColor || mode('white', DARK_FIELD_BG)(props),
        borderColor: mode('gray.100', DARK_FIELD_BORDER)(props),
      },
      hover: {
        color: mode('gray.800', DARK_FIELD_FG)(props),
        bgColor: props.bgColor || mode('white', DARK_FIELD_BG)(props),
        borderColor: mode('gray.200', DARK_FIELD_BORDER_HOVER)(props),
      },
      focus: {
        color: mode('gray.800', DARK_FIELD_FG)(props),
        bgColor: props.bgColor || mode('white', DARK_FIELD_BG)(props),
        borderColor: mode('green.400', '#14DCAC')(props),
      },
      filled: {
        color: mode('gray.800', DARK_FIELD_FG)(props),
        bgColor: props.bgColor || mode('white', DARK_FIELD_BG)(props),
        borderColor: mode('gray.300', DARK_FIELD_BORDER)(props),
      },
      readOnly: {
        color: mode('gray.800', DARK_FIELD_FG)(props),
        bgColor: mode('gray.200', 'gray.800')(props),
        borderColor: mode('gray.200', 'gray.800')(props),
      },
      // we use opacity to show the disabled state
      disabled: {
        opacity: 0.2,
      },
      error: {
        color: mode('gray.800', DARK_FIELD_FG)(props),
        bgColor: props.bgColor || mode('white', DARK_FIELD_BG)(props),
        borderColor: mode('red.500', 'red.500')(props),
      },
    },
    placeholder: {
      'default': {
        color: mode('gray.500', DARK_PLACEHOLDER)(props),
      },
      disabled: {
        color: transparentize('gray.500', 0.2)(props.theme),
      },
      error: {
        color: mode('red.500', 'red.500')(props),
      },
    },
  };
}
